<iss-circle-icon-button
  class="wo-remove-circle-icon-button"
  [name]="'delete'"
  [size]="size"
  [tooltip]="tooltip"
/>
